import { render, staticRenderFns } from "./m-section-store.vue?vue&type=template&id=58cd51bc&scoped=true&"
import script from "./m-section-store.vue?vue&type=script&lang=js&"
export * from "./m-section-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd51bc",
  null
  
)

export default component.exports